<template>
  <b-form @submit="onsubmit">
    <b-form-group v-for="exam in order.exams"
                  :label="$t('ordemResultado.modal.report_result_detail.resultado') + `: ${exam.exam_code}`"
                  class="m-3">
      <b-form-select
          v-model="exams[exam.exam_code]"
          :options="[
              {text: $t('ordemResultado.modal.report_result_detail.inconclusivo'), value: 'non_compliance'},
              {text: $t('ordemResultado.modal.report_result_detail.reagente'), value: 'positive'},
              {text: $t('ordemResultado.modal.report_result_detail.nao_reagente'), value: 'negative'}
          ]"
      />
    </b-form-group>
    <div class="d-flex justify-content-center">
      <b-btn variant="success" type="submit">
        {{ $t('ordemResultado.modal.report_result_detail.enviar_resultados') }}
      </b-btn>
    </div>
  </b-form>
</template>

<script>
import moment from "moment";
import {axiosbase} from "@/providers/AxiosServiceProvider";
import Cookies from "js-cookie";
import {mapActions} from "vuex";

export default {
  name: "ReportResultDetail",
  props: {
    identifier: {
      type: String
    },
    order: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      exams: []
    }
  },
  methods: {
    ...mapActions([
      'order/listRecipient'
    ]),
    onsubmit(evt) {
      evt.preventDefault()
      let date = new Date()
      let json = {
        id: this.identifier,
          resourceType: "DiagnosticReport",
          status: "final",
          issued: moment(date).format("YYYY-MM-DDTHH:mm:ss-03:00"),
          contained: []
      }

      this.order.exams.map(e => {
        if (
            typeof this.exams[e.exam_code] === 'undefined' ||
            this.exams[e.exam_code] === null
        ){
          this.$snotify.warning(this.$t('ordemResultado.modal.report_result_detail.informe_resultado_exame') + ` ${e.exam_code}`)
          return
        }

        if (e.exam_mapped_code === null || e.exam_mapped_code === "Erro de De X Para"){
          this.$snotify.warning(this.$t('ordemResultado.modal.report_result_detail.exame') + ` ${e.exam_code} ` + this.$t('ordemResultado.modal.report_result_detail.sem_de_para'))
          return
        }

        json.contained = [
          ...json.contained,
          {
            resourceType: "Observation",
            status: "final",
            id: e.exam_mapped_code,
            code: {
              coding: [
                {
                  code: e.exam_mapped_code
                }
              ]
            },
            valueQuantity: {
              value: this.exams[e.exam_code],
              unit: ""
            }
          }
        ]
      })

      if (json.contained.length >= this.order.exams.length) {
        const data = {
          report_content: JSON.stringify(json),
          device_name: this.order.vns,
          filename: `${moment(date).format("YYYYMMDD_HHmmss")}.xml`
        }
        axiosbase.post(
            '/api/v1/integration/report',
            data,
            {headers: {'Authorization': Cookies.get('vws_token')}}
        ).then(() => {
          this['order/listRecipient']({ identifier: this.identifier })
          this.$snotify.success(this.$t('ordemResultado.modal.report_result_detail.resultado_recebido'))
        }).catch(error => {
          this.$snotify.error(this.$t('ordemResultado.modal.report_result_detail.erro_transmitir_resultado'))
          console.log(error)
        })
      }
    }
  }
}
</script>
